import InstallAPI from "../../../../contents/docs/integrate/_snippets/install-api.mdx";
import * as React from 'react';
export default {
  InstallAPI,
  React
};